module.exports = __webpack_public_path__ + "static/media/binding_strirrups.802ddac9.webp";